// Returns cart data in json
const getCart = async () => {
  try {
    const res = await fetch('/cart.js');
    const data = await res.json();
    return data
  } catch (error) {
    console.log(error);
    return false
  }
}

// Seize checkout button click to check cart for
// bundle items needing for correct currency conversion
const checkForConversion = async (evt) => {
  evt.preventDefault();

  // Get current cart data
  const { items, item_count, currency: cartCurrency } = await getCart();

  // Do nothing if cart is empty
  if (item_count === 0) return;

  // Filter cart for bundle parent only and if their saved currency property does not match store
  const bundleItems = items.filter(({ properties }) => properties['_bundleItemType'] === "parent" && properties['_bundlePriceCurrency'] !== cartCurrency);

  // Continue form submission if conversion is not required
  if (!bundleItems.length) {
    window.location.href = '/checkout'
  }

  // Loop through filtered cart
  // /cart/change.js can only change one line item at a time
  // https://shopify.dev/docs/api/ajax/reference/cart#post-locale-cart-change-js
  for (const obj of bundleItems) {
    const { key, properties } = obj;
    const priceEl = document.querySelector(`.cart--item[data-item-key="${key}"] .cart--item--price .money`);
    if (!priceEl) continue;

    Object.assign(properties, {
      '_bundlePrice': priceEl.innerText,
      '_bundlePriceCurrency': cartCurrency,
      '_bundleDineroAmount': priceEl.dataset.dineroAmout ?? 0
    });

    try {
      const res = await fetch('/cart/change.js', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json'
        },
        body: JSON.stringify({
          properties,
          id: key
        })
      });
      const data = await res.json();
      console.log({ data });
    } catch (err) {
      console.log(err);
    }
  }

  // Continue with form submission
  window.location.href = '/checkout'
}

const init = () => {
  const submitToCheckoutBtns = document.querySelectorAll('button[name="checkout"]');
  submitToCheckoutBtns.forEach((btn) => {
    btn.addEventListener('click', checkForConversion)
  });
};

["DOMContentLoaded", 'cart:updated'].forEach((evt) => {
  document.addEventListener(evt, init);
});